import { vec3 } from 'gl-matrix';

export class BoundingSphere {
  constructor(
    public position: vec3 | number[],
    public radius: number,
  ) {}

  public isPointContained(point: vec3 | number[]): boolean {
    return vec3.dist(this.position, point) <= this.radius;
  }

  public intersects(sphere: BoundingSphere): boolean {
    let dist = vec3.distance(this.position, sphere.position);
    return dist < this.radius + sphere.radius;
  }

  public clone(): BoundingSphere {
    return new BoundingSphere(vec3.clone(this.position), this.radius);
  }
}
